import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import useSEO from "../hooks/useSEO";
import { api } from "../lib/api";
import { QJ_CATEGORIES } from "../lib/qj";

export default function QJMotor() {
  const [counts, setCounts] = useState({});

  useSEO({
    title: "QJ Motor — Nieuwe motoren | TT Motorsports Torhout",
    description: "Alle nieuwe QJ Motor-modellen bij TT Motorsports in Torhout: adventure, custom, sport en naked, met prijzen incl. btw en testritaanvraag.",
    keywords: "QJ Motor, QJMOTOR Torhout, QJ Motor dealer West-Vlaanderen, SRK, SRT, SRV, testrit",
  });

  useEffect(() => {
    api.get("/qj-models").then((r) => {
      const c = {};
      r.data.forEach((m) => (m.categorieen || []).forEach((k) => { c[k.toLowerCase()] = (c[k.toLowerCase()] || 0) + 1; }));
      setCounts(c);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="qj-overview-page" className="bg-[#0A0A0B] min-h-screen pt-32 md:pt-40 pb-20">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="flex justify-center mb-14 md:mb-20">
          <img data-testid="qj-logo" src="/qj/qjmotor-logo.png" alt="QJ MOTOR" className="w-[78%] sm:w-[60%] lg:w-[46%] max-w-[720px] h-auto" />
        </motion.h1>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-6 max-w-[1200px] mx-auto" data-testid="qj-categories">
          {QJ_CATEGORIES.map((c, i) => (
            <motion.div key={c.slug} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}>
              <Link to={`/qj-motor/categorie/${c.slug}`} data-testid={`qj-cat-${c.slug}`}
                className="group relative block aspect-[4/3] overflow-hidden border border-[#2A2B31] hover:border-[#5A5C63] transition-colors">
                <img src={c.img} alt={`QJ MOTOR ${c.label}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B]/90 via-[#0A0A0B]/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7 flex items-end justify-between gap-4">
                  <div>
                    <p className="font-mono-tt text-[10px] uppercase tracking-[0.25em] text-white/70 mb-1">{counts[c.label.toLowerCase()] || 0} modellen</p>
                    <h2 className="font-display uppercase font-800 text-3xl md:text-4xl text-white leading-none">{c.label}</h2>
                  </div>
                  <span className="shrink-0 w-11 h-11 bg-[#E10600] group-hover:bg-white text-white group-hover:text-[#0A0A0B] flex items-center justify-center transition-colors">
                    <ArrowRight size={18} className="transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
